export enum AppTableKeysData {
  INVOICE_TABLE_KEY = 'invoice-table',
  GRN_TABLE_KEY = 'grn-table',
  PAYMENT_TABLE_KEY = 'payment-table',
  EULA_VERSION_HISTORY = 'eula-version-history-table',
  EULA_USER_ACCEPTANCE = 'eula-user-acceptance-table',
  PROCESS_PAYMENT_TABLE_KEY = 'process-payment-table',
  ADDITIONAL_APPROVERS_TABLE_KEY = 'additional-approvers-payment-table',
  OCR_TABLE_KEY = 'ocr-table',
  PO_TABLE_KEY = 'po-table',
  V_D_CARDS_TABLE_KEY = 'vdc-table',
  PO_RECEIPT_TABLE_KEY = 'po-receipt-table',
  VENDOR_INVITATION_TABLE_KEY = 'invitation-table',
  VENDOR_GROUP_TABLE_KEY = 'group-table',
  VENDOR_REQUEST_TABLE_KEY = 'request-table',
  VENDOR_STATE_KEY = 'vendorState',
  ACCOUNT_TABLE_KEY = 'account-table',
  VCARD_TABLE_KEY = 'v-card-table',
  TICKET_TABLE_KEY = 'ticket-table',
  SUB_ACCOUNT_TABLE_KEY = 'sub-account-table',
  BILL_PAYMENT_TABLE_KEY = 'bill-payment-table',
  Item_TABLE_KEY = 'item-table',
  VENDOR_ITEM_TABLE_KEY = 'vendor-item-table',
  CUSTOMER_INVOICE_GRID_KEY = 'customer-invoice',
  CUSTOMER_INVOICE_LIST = 'CUSTOMER_INVOICE_LIST',
  CREDIT_NOTE_KEY = 'credit-note-table',
  CREDIT_NOTE_KEY_VENDOR = 'credit-note-vendor-table',
  PROJECT_BILL = 'project-bill-table',
  DASHBOARD_APPROVAL_TABLE_KEY = 'approval-table',
  DASHBOARD_DISCOUNT_TABLE_KEY = 'discount-table',
  VENDOR_DASHBOARD_BILL_TABLE_KEY = 'vendor-bill-table',
  VENDOR_DASHBOARD_PAYMENT_TABLE_KEY = 'vendor-payment-table',
  ADDITIONAL_FIELD_TABLE_KEY = 'additional-fields-table',
  PO_NUMBER_TABLE_KEY = 'po-number-table',
  EXPENSE_MILEAGE_RATE_LIST_TABLE_KEY = 'expense-mileage-table',
  PO_PRICE_VARIANCE_TABLE_KEY = 'po-price-variance-table',
  PROJECT_CODE_TABLE_KEY = 'project-code-table',
  ROLE_TABLE_KEY = 'role-table',
  VENDOR_TABLE_KEY = 'vendor-table',
  USER_TABLE_KEY = 'user-table',
  WORK_FLOW_TABLE_KEY = 'work-flow-table',
  ACCOUNT_SYNC_PENDING_TABLE_KEY = 'sync-pending',
  ACCOUNT_SYNC_COMPLETED_TABLE_KEY = 'sync-completed',
  ACCOUNT_SYNC_COMPLETED_PULL_TABLE_KEY = 'sync-completed-pull',
  ACCOUNT_SYNC_PROCESSING_TABLE_KEY = 'sync-processing',
  ACCOUNT_SYNC_FAILED_TABLE_KEY = 'sync-failed',
  ACCOUNT_SYNC_FAILED_PULL_TABLE_KEY = 'sync-failed-pull',
  APPROVAL_GROUP_TABLE_KEY = 'approval-group-table',
  DEPARTMENT_TABLE_KEY = 'department-table',
  GRID_NAME_RECURRING_Bill_TABLE_KEY = 'recurring-bill-table',
  BILL_TABLE_KEY = 'bill-table',
  NEGATIVE_BILL_LIST = 'negative-bill-list',
  RELEASE_PAYMENT = 'release-payment',
  VENDOR_TABLE_LIST = 'vendor-table',
  BILL_DISCOUNT_TABLE_KEY = 'discount-bill-table',
  EXPENSE_TABLE_KEY = 'expense-table',
  ADD_CARD_TABLE_KEY = 'add-card-table',
  REMINDER_TABLE_KEY = 'reminder-list',
  RECEIPT_CARD_TABLE_KEY = 'receipt-card-table',
  SUBMITTED_CARD_TABLE_KEY = 'submit-card-table',
  UPLOAD_CARD_TABLE_KEY = 'upload-card-table',
  PROCESS_CARD_TABLE_KEY = 'process-card-table',
  RECEIPT_POPUP_TABLE_KEY = 'receipt-popup-table',
  PAYMENT_APPROVED_BILL_TABLE_KEY = 'payment-approved-bills-table',
  PAYMENT_UNDER_APPROVED_BILL_TABLE_KEY = 'payment-under-approved-bills-table',
  BATCH_DETAIL_TABLE_KEY = 'batch-detail-table',
  BATCH_PAYMENT_TABLE_KEY = 'batch-payment-detail-table',
  VENDOR_SUMMARY_TABLE_KEY = 'vendor-summary-table-key',
  VENDOR_SUMMARY_PAYMENT_TABLE_KEY = 'vendor-summary-payment-table-key',
  VENDOR_PAYMENT_UNDER_APPROVED_BILL_KEY = 'vendor_payment-approved-bills-table',
  VENDOR_PAYMENT_APPROVED_BILL_KEY = 'vendor_payment-under-approved-bills-table',

  PAYMENT_BATCH_TABLE_KEY = 'payment-batch-table',
  PAYMENT_UNDER_BATCH_TABLE_KEY = 'payment-under-batch-table',
  PAYMENT_VENDOR_TABLE_KEY= 'payment-vendor-table',
  PAYMENT_UNDER_VENDOR_TABLE_KEY = 'payment-under-vendor-table',

  PAYMENT_REVIEW_TABLE_KEY = 'payment-review-table',
  PAYMENT_UNDER_REVIEW_KEY = 'payment-under-review-table',

  // Support
  TASK_TABLE_KEY = 'task-table-key',
  TENANT_TABLE_KEY = 'tenant-table-key',
  ACTIVITY_TABLE_KEY = 'activity-table-key',
  ACTIVE_LOGINS_TABLE_KEY = 'active-logins-table-key',
  EMAIL_TABLE_KEY = 'email-table-key',
  INTEGRATION_SYSTEM_TABLE_KEY = 'system-table-key',
  INTEGRATION_CONFIGURATION_TABLE_KEY = 'config-table-key',
  PAYMENT_TYPE_TABLE_KEY = 'payment-type-table-key',
  PAYMENT_PROVIDER_TABLE_KEY = 'payment-provider-table-key',
  BILL_EXP_TABLE = 'create-bill-exp',
  BILL_ITM_TABLE = 'create-bill-itm',

  RESTORE_COLUMN_WIDTHS_TIME_OUT = 100,
  RESTORE_COLUMN_ORDER_TIME_OUT = 800,
  REMOVE_TABLE_ITEM_TIME_OUT = 200,
  TABLE_CHANGES_TIME_OUT = 100,


}

